import angular from 'angular';

function lwCounter() {
  return {
    restrict: 'E',
    template: require('./lw-counter.html'),
    scope: {
      count: '='
    },
    transclude: true,
    link: function (scope, element, attrs) {
      angular.element(element).addClass('counter');
      /*
        attrs
        ----------------------------------------
        name: The name of the thing being counted
        list: The list or map of things to count
       */
      // scope.count = scope.list ? scope.list.size : 0;
      scope.name = scope.$eval(attrs.name) + (scope.count !== 1 ? 's' : '');
    }
  };
}

export default angular.module('directives.lfAccountList', [])
  .directive('lwCounter', lwCounter)
  .name;



// WEBPACK FOOTER //
// ./project/directives/lw-counter/index.js